var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#1A1B1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1874_6880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.849 31.5443V29.387H25.2626C25.0521 29.387 24.8436 29.4269 24.6492 29.5045C24.4547 29.582 24.2781 29.6957 24.1293 29.839C23.9806 29.9823 23.8627 30.1524 23.7824 30.3396C23.7021 30.5268 23.6609 30.7273 23.6613 30.9298V38.8182H19V22.8885L23.6613 26.7021V24.9035H28.849V22.7461L34.3548 27.1452L28.849 31.5443Z",
    fill: "#FF534A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9287 18.1649C35.9287 18.5736 35.7601 18.9656 35.4599 19.2549C35.1596 19.5442 34.7524 19.707 34.3274 19.7077H23.6613V17.9011L19 21.7121V15.2163H35.9287V18.1649Z",
    fill: "#FF534A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1874_6880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 24,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmIcon);
export default __webpack_public_path__ + "static/media/farmIcon.05c9670b0ce79d59905be52f5e5e4a34.svg";
export { ForwardRef as ReactComponent };